export const comments_5618938 = {"data":{"data":[],"links":{}}}